module.exports = __webpack_public_path__ + "static/media/niuw-background.518d4a91.jpg";